/** @jsx h */
import { h } from 'preact'

import Logo from '../Logo'
import ExternalLinkIcon from '../icons/ExternalLinkIcon'
import t from '../../../utils/translate'

const ProvenanceValue = () => (
  <div class='ProvenanceValue'>
    <Logo />
    <p class='CaptionUI--regular Text--colourIron u-marginTop8'>
      {t('journeys.js.value.description')}
    </p>
    <a
      class='ExternalLink CaptionUI--regular'
      href='/shoppers?utm_source=productstory&utm_medium=endCTA'
      rel='noopener noreferrer'
      target='_blank'
    >
      {t('journeys.js.value.link')}
      <ExternalLinkIcon />
    </a>
  </div>
)

export default ProvenanceValue
